import { PoContractCreateData } from "@/features/private-room/bookings/context/use-booking-flow/use-booking-flow.types";
import { FieldsToUpdate } from "@/features/private-room/bookings/context/use-po-contracts-update-flow/use-po-contracts-update-flow.types";
import { parseMoneyValue } from "@/utils/parse-money";
import { apiWobaBackend } from "@/services/api-woba-backend";

export const useCreatePoContract = () => {
  const handleCreatePoContract = async (data: PoContractCreateData) => {
    const { poType, ...restData } = data;
    const createPoContractPayload = {
      ...restData,
      companyId: Number(data.companyId),
      userId: Number(data.contractResponsibleUser),
      packageId: Number(data.packageId),
      spaceId: Number(data.coworkingId),
      spotId: data.privateOfficeId,
      type: data.contractType,
      expectedDurationMonths: Number(data.expectedDurationMonths),
      takePercentage: data.takeRatePercentage,
      partnerPrice: parseMoneyValue(data.partnerValue),
      monthlyCredits: data.monthlyCredits,
      noticeInDaysCompany: Number(data.noticeInDaysClient),
      noticeInDaysPartner: Number(data.noticeInDaysPartner),
      userManagerId: Number(data.roomResponsibleUser),
      members: Number(data.members),
      partnerAssignmentTermId: Number(data.acceptanceTerm),
      companyAssignmentTermId: Number(data.knowledgeTerm),
      ...(data.contractType === "po" ? { poType } : {}),
    };

    const response = await apiWobaBackend.post(
      "/private-offices/contracts",
      createPoContractPayload,
    );
    return response.status === 201;
  };

  const handleUpdatePoContract = async (
    contractId: number,
    alteredFields: FieldsToUpdate,
  ) => {
    const fieldMapping: Record<string, string> = {
      contractResponsibleUserId: "userId",
      roomResponsibleUserId: "userManagerId",
      partnerValue: "partnerPrice",
      noticeInDaysClient: "noticeInDaysCompany",
      acceptanceTerm: "partnerAssignmentTermId",
      knowledgeTerm: "companyAssignmentTermId",
      hasUndeterminedTime: "setToIndeterminate",
    };

    const updatePoContractPayload = Object.entries(alteredFields).reduce(
      (acc, [key, value]) => {
        acc[fieldMapping[key] || key] = value;
        return acc;
      },
      {} as Record<string, unknown>,
    );

    try {
      const response = await apiWobaBackend.patch(
        `/private-offices/contracts/${contractId}`,
        updatePoContractPayload,
      );
      return response.status === 200;
    } catch (error) {
      return false;
    }
  };

  return {
    handleCreatePoContract,
    handleUpdatePoContract,
  };
};
